/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';

import {Box, Spinner} from '@salesforce/retail-react-app/app/components/shared/ui';

const LoadingSpinner = ({wrapperStyles = {}, spinnerStyles = {}}) => {
  return (
    <Box
      background="whiteAlpha.800"
      bottom="0"
      left="0"
      position="absolute"
      right="0"
      top="0"
      zIndex="overlay"
      {...wrapperStyles}
    >
      <Spinner
        data-testid="loading"
        {...spinnerStyles}
        color="blue.600"
        emptyColor="gray.200"
        left="50%"
        ml="-1.5em"
        mt="-1.5em"
        position="absolute"
        size="xl"
        speed="0.65s"
        thickness="4px"
        top="50%"
      />
    </Box>
  );
};

LoadingSpinner.propTypes = {
  wrapperStyles: PropTypes.object,
  spinnerStyles: PropTypes.object,
};

export default LoadingSpinner;
